import * as React from 'react';

import { Button, Flex, Input, Typography } from 'antd';

import { AntdRouterLink, PlusOutlinedIcon } from 'components';
import { PATHNAME } from 'utils';

const {
  DEFAULT: { SLUG_SEPARATOR: DEFAULT_SLUG_SEPARATOR },
  LOCAL: {
    PACKAGING_MODELS: { CREATE_URL: PACKAGING_MODELS_CREATE_URL },
  },
} = PATHNAME;

type PackagingModelsHeaderProps = {
  searchKey: string;
  handleSearchKey: (searchKey: string) => void;
};

const PackagingModelsHeader = ({
  searchKey,
  handleSearchKey,
}: PackagingModelsHeaderProps) => (
  <Flex
    gap='small'
    className='mb-5 max-lg:flex-col lg:items-center lg:justify-between'
  >
    <Typography.Title level={1} className='mb-0 text-lg'>
      بسته‌بندی‌ها
    </Typography.Title>
    <Flex gap='small' className='max-lg:flex-wrap'>
      <Input.Search
        allowClear
        styles={{
          affixWrapper: {
            height: '2.5rem',
          },
        }}
        placeholder='جستجوی بسته‌بندی‌ها'
        defaultValue={searchKey}
        onSearch={value => handleSearchKey(value)}
      />
      <AntdRouterLink
        to={`${PACKAGING_MODELS_CREATE_URL}${DEFAULT_SLUG_SEPARATOR}`}
        className='max-lg:basis-full'
      >
        <Button type='primary' className='w-full' icon={<PlusOutlinedIcon />}>
          افزودن بسته‌بندی
        </Button>
      </AntdRouterLink>
    </Flex>
  </Flex>
);

export { PackagingModelsHeader };
